module.exports = __webpack_public_path__ + "media/images/meeting/ic_team_member-1f61a685c1b083d4067fb4e904cf4f04.svg";